import { PRESENCE_NOTIFICATION_TYPE } from 'constants/presence';

export const PRESENCE_TOAST_AUTO_DISMISS_MS = 3500;

export const PRESENCE_TOAST_MESSAGE = {
  [PRESENCE_NOTIFICATION_TYPE.JOINED]: 'joined this loan',
  [PRESENCE_NOTIFICATION_TYPE.LEFT]: 'left this loan',
};
